// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stationKey: __t.string().primaryKey().name("station_key"),
  role: __t.string(),
  berths: __t.u8(),
  busy: __t.u8(),
  source: __t.string(),
  operatorFirmId: __t.u64().name("operator_firm_id"),
  partsAvail: __t.u32().name("parts_avail"),
  reliefStock: __t.u32().name("relief_stock"),
  reliefCap: __t.u32().name("relief_cap"),
  reliefHour: __t.u64().name("relief_hour"),
  budgetDay: __t.u64().name("budget_day"),
  budgetUsed: __t.u32().name("budget_used"),
  outage: __t.string(),
  numbersJson: __t.string().name("numbers_json"),
  changedAt: __t.timestamp().name("changed_at"),
  checkedAt: __t.timestamp().name("checked_at"),
});
